import { render, staticRenderFns } from "./FormCreateWidget.vue?vue&type=template&id=5b7c4184&"
import script from "./FormCreateWidget.vue?vue&type=script&lang=js&"
export * from "./FormCreateWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports